import { render, staticRenderFns } from "./EmbedHeaderTodayButton.vue?vue&type=template&id=4a4934d8&"
import script from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js&"
export * from "./EmbedHeaderTodayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports